<template>
    <div>
        <div class="line"></div>
        <div class="device-title reveal-bottom">{{ $t("dv.dt") }}</div>
        <!-- 第一行 -->
        <div class="box">
            <div class="box-device-name reveal-bottom">
                <div class="box-device-title">{{ $t("dv.dn") }}</div>
                <div class="box-device-cont">
                    <img class="r200" :src="r200" alt="r200" />
                    <div class="device-text r200-text ">R200</div>
                </div>
                <div class="box-device-cont">
                    <img class="s50" :src="s50" alt="s50" />
                    <div class="device-text s50-text">S50</div>
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.das") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.ryc") }}/{{ $t("dv.ryc1") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.sy") }}/{{ $t("dv.sy1") }}
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    16G
                </div>
                <div class="box-device-des-cont ver-mid">
                    256MB
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    CPU
                </div>
                <div class="box-device-des-cont ver-mid">
                    Intel(R) Celeron(R) CPU G1620 @ 2.70GHz
                </div>
                <div class="box-device-des-cont ver-mid">
                    MediaTek MT7628NN
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd4") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.rsk") }} x1USB2.0 x 21000Mbps LAN x 41000Mbps WAN
                    x 2
                </div>
                <div class="box-device-des-cont ver-mid">
                    MicroUSB {{ $t("dv.s5p") }} x 1 10/100Mbps WAN x 1
                    10/100Mbps LAN x 1
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd3") }} (WxDxH)
                </div>
                <div class="box-device-des-cont ver-mid">
                    430mm*280mm*44mm
                </div>
                <div class="box-device-des-cont ver-mid">
                    70mm*70mm*21.5mm
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.dcn") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.ruc") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.s5u") }}
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd1") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    400Mbps
                </div>
                <div class="box-device-des-cont ver-mid">
                    5Mbps
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd2") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    2Gbps
                </div>
                <div class="box-device-des-cont ver-mid">
                    300Mbps
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.ra") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.rac") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.rac") }}
                </div>
            </div>
        </div>
        <!-- 第二行 -->
        <div class="box" style="margin-top:60px;">
            <div class="box-device-name reveal-bottom">
                <div class="box-device-title">{{ $t("dv.dn") }}</div>
                <div class="box-device-cont">
                    <img class="s200" :src="s200" alt="s200" />
                    <div class="device-text s200-text ">S200</div>
                </div>
                <div class="box-device-cont">
                    <img class="d100" :src="d100" alt="d100" />
                    <div class="device-text d100-text">D100</div>
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.das") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.sy") }} / {{ $t("dv.sy1") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.sy") }} / {{ $t("dv.sy1") }}
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    256MB
                </div>
                <div class="box-device-des-cont ver-mid">
                    2G
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    CPU
                </div>
                <div class="box-device-des-cont ver-mid">
                    MT7632A
                </div>
                <div class="box-device-des-cont ver-mid">
                    Intel(R) Celeron(R) CPU J1900 @ 1.99GHz
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd4") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    SIM/{{ $t("dv.sg") }} LTE x 1 1000Mbps WAN x 1 1000Mbps LAN
                    x 1
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.ds") }} x 1 1000Mbps WAN x 1 1000Mbps LAN x 4
                    USB2.0 x 2
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd3") }} (WxDxH)
                </div>
                <div class="box-device-des-cont ver-mid">
                    220mm*220mm*35mm
                </div>
                <div class="box-device-des-cont ver-mid">
                    197mm*174mm*35mm
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.dcn") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.suc") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.duc") }}
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd1") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    2Mbps – 20Mbps
                </div>
                <div class="box-device-des-cont ver-mid">
                    150Mbps
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd2") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    2Gbps
                </div>
                <div class="box-device-des-cont ver-mid">
                    1Gbps
                </div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.ra") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.dac") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.aic") }}
                </div>
            </div>
        </div>
        <!-- 第三行 -->
        <div class="box" style="margin-top:60px;">
            <div class="box-device-name reveal-bottom">
                <div class="box-device-title">{{ $t("dv.dn") }}</div>
                <div class="box-device-cont">
                    <img class="a55" :src="a55" alt="a55" />
                    <div class="device-text a55-text ">A55</div>
                </div>
                <div class="box-device-cont"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.das") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.dy") }} / {{ $t("dv.auc") }}
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    2G
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    CPU
                </div>
                <div class="box-device-des-cont ver-mid">
                    H6 Quad-core 64-bit ARM Cortex™-A53
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd4") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.aic") }} 1000 WAN x 1 Type C USB2.0 x 1
                    Zigbee/Bluetooth/NFC
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd3") }} (WxDxH)
                </div>
                <div class="box-device-des-cont ver-mid">
                    120mm*52mm*11mm
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.dcn") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.anc") }}
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd1") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    20Mbps
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.rd2") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    600Mbps
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
            <div class="box-device-des reveal-bottom">
                <div class="box-device-des-title ver-mid">
                    {{ $t("dv.ra") }}
                </div>
                <div class="box-device-des-cont ver-mid">
                    {{ $t("dv.dac") }}
                </div>
                <div class="box-device-des-cont ver-mid"></div>
            </div>
        </div>
    </div>
</template>
<script>
import initAnimation from "../animation";
export default {
    data() {
        return {
            r200: require("@/assets/images/devices/R200_c.png"),
            s50: require("@/assets/images/devices/S50_c.png"),
            s200: require("@/assets/images/devices/s200_c.png"),
            d100: require("@/assets/images/devices/d100_c.png"),
            a55: require("@/assets/images/devices/a55_c.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
};
</script>
<style scoped>
.line {
    height: 10px;
    background: #f2f2f2;
}
.device-title {
    font-size: 64px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    font-weight: bold;
    line-height: 96px;
    margin: 100px auto 96px;
}
.box {
    width: 1200px;
    margin: auto;
    border-top: 2px solid #000;
}
.box-device-name {
    display: flex;
    height: 222px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.box-device-title {
    flex-basis: 196px;
    padding-bottom: 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: right;
    font-weight: bold;
    line-height: 33px;
    padding-right: 49px;
}
.box-device-cont {
    flex: 1;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 25px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-left: 19px;
}
.r200 {
    width: 128px;
    height: 84px;
}
.device-text {
    margin-top: 36px;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    line-height: 33px;
    text-align: center;
    font-weight: bold;
}
.r200-text {
    width: 128px;
}
.s50 {
    width: 109px;
    height: 76px;
}
.s50-text {
    width: 109px;
}
.s200 {
    width: 144px;
    height: 109px;
}
.s200-text {
    width: 144px;
}
.d100 {
    width: 141px;
    height: 86px;
}
.d100-text {
    width: 141px;
}
.a55 {
    width: 153px;
    height: 105px;
}
.a55-text {
    width: 153px;
}
.box-device-des {
    display: flex;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.box-device-des-title {
    padding-right: 49px;
    box-sizing: border-box;
    text-align: right;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    letter-spacing: 0;
    font-weight: bold;
    width: 196px;
    line-height: 24px;
}
.ver-mid {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 54px;
}
.box-device-des-cont {
    flex: 1;
    padding-left: 57px;
    box-sizing: border-box;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 30px;
    font-family: Helvetica, "PingFang SC", "Microsoft Yahei",
        "WenQuanYi Micro Hei", Arial, Verdana, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Hardware/Diff.vue